/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';  
import { getAllAuthProvider, getAuthProviderHistory } from './authProviderActions';

const initialState = {
    data: {},
    authProviders: {},
    authProviderHistory: {}
}
const authProviderSlice = createSlice({
    name: 'authProvider',
    initialState,
    extraReducers: {

        [getAllAuthProvider.fulfilled]: (state, { payload }) => {
            state.authProviders =  payload;
        },
        [getAuthProviderHistory.fulfilled]: (state, { payload }) => {
            state.authProviderHistory =  payload;
        },
        [getAuthProviderHistory.rejected]: (state, { payload }) => {
            state.authProviderHistory =  {};
        },
    }
});

export default authProviderSlice.reducer